import moment from "moment";
import { EmployeeDropdownResult } from "../employee";

export class MeetingRoomScheduleResult {
    public id: number = 0;
    public fromDateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public toDateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public meetingRoomId = 0;
    public meetingRoomName = '';
    public meetingRoomColorClass = '';
    public customerId: number | null = null;
    public customerName = '';
    public description = '';
    public customerLogoFileName = '';
    public employeeWhoAttendToTheMeetingList: Array<EmployeeDropdownResult> = [];
    public isDeleted: boolean = false;
    public meetingRoomScheduleResultList = '';
    public otherCustomerName = '';

    // front-end
    public employees = '';
}
